import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/styles';

import NotFound from './Containers/NotFound';
import Theme from './Theme';
import { CssBaseline } from '@material-ui/core';
import PrivateRoute from './Routes/PrivateRoute';
import CustomRoute from './Routes/CustomRoute';
import routes from './Routes/routes';
import { ApolloProvider } from '@apollo/client';
import { getAccessToken } from './Services/LocalStorage';
import { createClient } from './Services/ApolloClient';
import { AuthProvider } from './Providers/AuthProvider';

const App = () => {
  console.log('<<<<<<<<<< TEST LOG 1 >>>>>>>>>>');
  const token = getAccessToken();
  const client = createClient(token ?? '');

  // Routes
  const getRoutes = () => {
    return routes.map(({ key, path, component, isExact, isPrivate, roles }) =>
      isPrivate ? (
        <PrivateRoute key={key} exact={isExact} path={path} component={component} roles={roles} />
      ) : (
        <CustomRoute key={key} exact={isExact} path={path} component={component} roles={roles} />
      )
    );
  };
  return (
    <ApolloProvider client={client}>
      <ThemeProvider theme={Theme}>
        <AuthProvider>
          <CssBaseline />
          <BrowserRouter>
            <Switch>
              {getRoutes()}
              <Route component={NotFound} />
            </Switch>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </ApolloProvider>
  );
};

export default App;
